import { DealLaScSection } from "@/types/dealLaSc.types";
import {
  TableCreatorSubGroupShellTableList,
  TableCreatorTableList,
} from "@FillInTableContainer/shared/types/tableCreator.types";

interface DealLaScKeyCommentLayout {
  groupTableKey: DealLaScSection;
  tableList: TableCreatorTableList;
}

interface DealLaScKeyCommentListLayout {
  groupTableKey: DealLaScSection;
  tableList: TableCreatorSubGroupShellTableList;
}
export const DEAL_LA_SC_KEY_COMMENT_GROUP_TABLE_LAYOUT: DealLaScKeyCommentLayout =
  {
    groupTableKey: "Key Comment",
    tableList: [
      {
        tableKey: null,
        groupShellList: [
          {
            groupShellKey: null,
            shellList: [
              {
                shellKey: "Quote",
              },
              {
                shellKey: "Spokesperson",
              },
            ],
          },
        ],
      },
    ],
  };

export const DEAL_LA_SC_KEY_COMMENT_LIST_GROUP_TABLE_LAYOUT: DealLaScKeyCommentListLayout =
  {
    groupTableKey: "Key Comment List",
    tableList: [
      {
        tableKey: null,
        groupShellList: [
          {
            groupShellKey: null,
            subGroupShellList: [
              {
                subGroupShellKey: "Key Comment List",
                shellList: [
                  {
                    shellKey: "Comment Quote",
                  },
                  {
                    shellKey: "Comment Spokesperson",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  };
